module.exports = "/images/lock-icon.png?0bda6384df86ad96a02e284491c1c95b";